import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const theme = useTheme();

    // menu list collapse & items
    const items = item.children?.map(menu => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant='h6' color='error' align='center'>
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography
                            variant='caption'
                            sx={{
                                ...theme.typography.menuCaption,
                                color: 'rgba(255,255,255,0.95)',
                                fontWeight: 600,
                                fontSize: '0.6875rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                mb: 1,
                                mt: 0.5,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                px: 1,
                                py: 0.5,
                                borderRadius: '6px',
                                background: 'rgba(255,255,255,0.1)',
                                border: '1px solid rgba(255,255,255,0.12)',
                            }}
                            display='block'
                            gutterBottom
                        >
                            <Box
                                component='span'
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '4px',
                                    background: 'rgba(255,255,255,0.2)',
                                    fontSize: '0.75rem',
                                }}
                            >
                                📋
                            </Box>
                            {item.title}
                            {item.caption && (
                                <Typography
                                    variant='caption'
                                    sx={{
                                        ...theme.typography.subMenuCaption,
                                        color: 'rgba(255,255,255,0.7)',
                                        fontSize: '0.75rem',
                                        mt: 0.5,
                                        fontWeight: 400,
                                    }}
                                    display='block'
                                    gutterBottom
                                >
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider
                sx={{
                    mt: 1.5,
                    mb: 1.5,
                    borderColor: 'rgba(255,255,255,0.15)',
                    opacity: 0.5,
                    borderWidth: '1px',
                }}
            />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
};

export default NavGroup;
